import { styled } from '@grupoboticario/flora-react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

const HEADER_HEIGHT = 62;

export const Wrapper = styled('section', {
  display: 'block',
  width: '100%',
  maxHeight: '100%',
  position: 'fixed',
  bottom: 0,
  left: 0,
  transform: `translateY(calc(100% - ${HEADER_HEIGHT}px))`,
  transition: '200ms ease-in-out all',
  zIndex: '$modal',
  variants: {
    isOpened: {
      true: {
        transform: `translateY(0)`,
      },
    },
  },
});

export const Header = styled('header', {
  background: '$light-dark-2',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: HEADER_HEIGHT,
  borderRadius: '$medium $medium 0 0',
  padding: '$0 $8',
  boxShadow: '$upSoft',

  variants: {
    center: {
      true: {
        justifyContent: 'center',
        svg: {
          marginRight: '$2',
        },
      },
    },
  },
});

export const StyledExpandIcon = styled(ExpandMoreIcon, {
  transition: '300ms ease-in-out all',
  color: '$brand-1',
  variants: {
    isOpened: {
      false: {
        transform: 'rotate(180deg)',
      },
    },
  },
});

export const StyledCloseIcon = styled(CloseIcon, {
  color: '$brand-1',
});

export const StyledBackIcon = styled(KeyboardBackspaceIcon, {
  color: '$brand-1',
});

export const Content = styled('div', {
  display: 'block',
  background: '$light-dark-2',
  padding: `0 $2 $6`,
  width: '100%',
  maxHeight: '100vh',
  overflowX: 'hidden',
  paddingBottom: '130px',

  '@supports (-webkit-touch-callout: none)': {
    paddingBottom: '180px',
  },
});
